jQuery.fn.live = function (types, data, fn) {
    try {
        if (typeof (this.selector) == "undefined" && typeof (this[0].id) != "undefined") {
            this.selector = String("#" + this[0].id);
        }
    } catch (e) {
    }

    if (typeof (this.context) == "undefined") {
        this.context = jQuery(this).parent();
    }

    jQuery(this.context).on(types, this.selector, data, fn);
    return this;
};
